import { all, call, put, takeLatest } from "redux-saga/effects";
import routeService from "../../services/routeService";
import { routeActions } from "../slices/routeSlice";

function* createRouteSaga({ payload }) {
  try {
    const data = yield call(routeService.createRoute, {
      routes: payload.routes,
    });

    yield put(routeActions.createRouteSuccess(data));

    payload.onSuccessfullyCreatedRoute();
  } catch (e) {
    yield put(routeActions.createRouteError(e.response.data));
    payload.onErrorCreatedRoute();
  }
}

function* updateRouteSaga({ payload }) {
  try {
    yield call(routeService.updateRoute, {
      routes: payload.form,
      routeId: payload.routeId,
    });

    yield put(routeActions.updateRouteSuccess());

    payload.onSuccessUpdateRoute();
  } catch (e) {
    yield put(routeActions.updateRouteError(e.response.data));
  }
}

function* getRoutesSaga() {
  try {
    const data = yield call(routeService.getAllRoutes);

    yield put(routeActions.getRoutesSuccess(data));
  } catch (e) {
    yield put(routeActions.getRoutesError(e.response.data));
  }
}

function* getRoutesByRouteIdSaga({ payload }) {
  try {
    const data = yield call(routeService.getRoutesByRouteId, payload);
    yield put(routeActions.getRoutesByRouteIdSuccess(data));
  } catch (e) {
    yield put(routeActions.getRoutesByRouteIdSuccess(e.response.data));
  }
}

function* getRoutesByDestinationTypeSaga({ payload }) {
  try {
    const data = yield call(routeService.getRoutesByDestinationType, {
      destinationTypeId: payload.destinationTypeId,
      date: payload.date,
      search: payload.search,
    });

    yield put(routeActions.getRoutesByDestinationTypeSuccess(data));
  } catch (e) {
    yield put(routeActions.getRoutesByDestinationTypeError(e.response.data));
  }
}

function* updateRouteOrderSaga({ payload }) {
  try {
    const data = yield call(routeService.updateRouteOrder, payload);

    yield put(routeActions.updateRouteOrderSuccess(data));
  } catch (e) {
    yield put(routeActions.updateRouteOrderError(e.response.data));
  }
}

function* updateRouteAsSentSaga({ payload }) {
  try {
    const data = yield call(routeService.updateRouteAsSent, payload.payload);

    yield put(routeActions.updateRouteAsSentSuccess(data));

    payload.onSucceededSentRoute();
  } catch (e) {
    yield put(routeActions.updateRouteAsSentError(e.response.data));
  }
}

function* cancelledRouteSaga() {
  try {
    const data = yield call(routeService.getCancelledRoutes);

    yield put(routeActions.getCancelledRoutesSuccess(data));
  } catch (e) {
    yield put(routeActions.getCancelledRoutesError(e.response.data));
  }
}

function* createMarkerSaga({ payload }) {
  try {
    yield call(routeService.createMarker, {
      date: payload.date,
      isAnotherWay: payload.isAnotherWay,
      isMarker: payload.isMarker,
      order: payload.order,
      destinationId: payload.destinationId,
    });

    payload.onAddedMarkerSuccessfully();
  } catch (e) {
    yield put(routeActions.createMarkerError(e.response.data));
  }
}

function* deleteMarkerSaga({ payload }) {
  try {
    yield call(routeService.deleteMarker, {
      id: payload.id,
    });

    payload.onDeletedMarkerSuccessfully();
  } catch (e) {
    yield put(routeActions.deleteMarkerError(e.response.data));
  }
}

function* softDeleteRouteSaga({ payload }) {
  try {
    const data = yield call(routeService.softDeleteRoute, { id: payload.id });

    payload.onSuccessfulySoftDeleteRoute();

    if (data !== null && data.id > 0) {
      yield put(routeActions.softDeleteRouteSuccess(data));
    }

    payload.onSuccessfulySoftDeleteReturnRoute();
  } catch (e) {
    yield put(routeActions.softDeleteRouteError(e.response.data));
  }
}

export default function* routeSaga() {
  yield all([
    takeLatest("route/createRoutePost", createRouteSaga),
    takeLatest("route/updateRoutePut", updateRouteSaga),
    takeLatest("route/updateRouteAsSentPut", updateRouteAsSentSaga),
    takeLatest("route/updateRouteOrderPut", updateRouteOrderSaga),
    takeLatest("route/getRoutesFetch", getRoutesSaga),
    takeLatest("route/getRoutesByRouteIdFetch", getRoutesByRouteIdSaga),
    takeLatest(
      "route/getRoutesByDestinationTypeFetch",
      getRoutesByDestinationTypeSaga
    ),
    takeLatest("route/getCancelledRoutesFetch", cancelledRouteSaga),
    takeLatest("route/createMarker", createMarkerSaga),
    takeLatest("route/deleteMarker", deleteMarkerSaga),
    takeLatest("route/softDeleteRouteFetch", softDeleteRouteSaga),
  ]);
}
